import React from 'react';
import loadable from '@loadable/component';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { getFeaturedListingsProps } from '../../util/data';
import { fetchFeaturedListings } from '../../ducks/featuredListings.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './TermsOfServicePage.duck';

const PageBuilderStyled = loadable(() =>
  import(/* webpackChunkName: "PageBuilderStyled" */ '../PageBuilder/PageBuilderStyled')
);

const TermsOfServicePageStyledComponent = (props: any) => {
  const { pageAssetsData, inProgress, error } = props;

  return (
    <PageBuilderStyled
      pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage />}
      featuredListings={getFeaturedListingsProps(camelize(ASSET_NAME), props)}
    />
  );
};

const mapStateToProps = (state: any) => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const featuredListingData = state.featuredListings || {};
  const getListingEntitiesById = (listingIds: any) => getListingsById(state, listingIds);
  return { pageAssetsData, featuredListingData, getListingEntitiesById, inProgress, error };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchFeaturedListings: (sectionId: any, parentPage: any, listingImageConfig: any, allSections: any) =>
    dispatch(fetchFeaturedListings({ sectionId, parentPage, listingImageConfig, allSections })),
});

const TermsOfServicePageStyled = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(TermsOfServicePageStyledComponent);

export default TermsOfServicePageStyled;
